export const TOUR_STYLES = {
    popover: (base, { position }) => {
        const style = {
            ...base,
            backgroundColor: "#F9F6BF",
            border: "1px solid #3D4146",
            fontFamily: "'Source Sans Pro', sans-serif",
            borderRadius: 10,
        };

        return style;
    },
    maskWrapper: (base) => ({ ...base, color: "rgba(0, 0, 0, 0.4)" }),
};

export const TOUR_STEPS = [
    {
        selector: ".tde-case-card",
        content:
            "The Case Card shows your dataset one case at a time, like a stack of cards. Drag any attribute (e.g., Age, Score) from the card into the plotting area to make a graph.",
    },
    {
        selector: ".tde-toolbar-panel",
        content:
            "Use the toolbar to choose a graph, add lines/labels, show numbers or %, add statistics such as the mean, or apply a function.",
    },
    {
        selector: ".tde-plotview-wrapper",
        content:
            "Drag attributes from the Case Card to the drop zones in the graphing area to create and see your graph.",
        width: 100,
    },
    {
        selector: ".tde-table-header > .tde-btn-plain:nth-child(2)",
        content:
            "Open the Table View to see your data as a table; click a column header to sort, or click a row to select that case—it will also be selected in the Case Card and graphing area.",
        position: "top",
    },
    {
        selector: ".tde-table-header > .tde-btn-plain:nth-child(3)",
        content:
            "Open the Summary View to see your graph’s statistics and parameters—counts, percentages, means, and fitted equations.",
        position: "top",
    },
];

export const TOUR_STEPS_JR_PLAY_VIEW = [
    {
        selector: ".tde-case-card",
        content:
            "This is the place where all the Cards live. Each Card stands for one item in the dataset. The Cards stay face down, and you can hover over them to see the name.",
    },
    {
        selector: ".tde-plotview-wrapper",
        content:
            "The Play Area contains the drop area where you can drag a Card so it flips and shows all its attributes.",
        width: 100,
    },
    {
        selector: ".tde-toolbar-panel",
        content:
            "Use the toolbar to spread out your Cards, browse them as icons, check your Card count, reset the Play Area, or move into Plot View.",
    },
];

export const TOUR_NAVIGATION = (props) => {
    const { setCurrentStep, currentStep, steps, setIsOpen } = props;
    const isLastStep = currentStep === steps.length - 1;

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: 20,
            }}
        >
            {/* Next button */}
            <button
                style={{
                    backgroundColor: "rgba(104, 45, 138, 1)",
                    color: "white",
                    border: "none",
                    padding: "8px 16px",
                    borderRadius: 4,
                    cursor: "pointer",
                }}
                onClick={() => {
                    if (isLastStep) {
                        setIsOpen(false);
                        setCurrentStep(0);
                    } else {
                        setCurrentStep((s) => s + 1);
                    }
                }}
            >
                {isLastStep ? "Close" : "Next"}
            </button>
            {/* skip button */}
            {!isLastStep && (
                <button
                    style={{
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                    }}
                    onClick={() => {
                        setIsOpen(false);
                    }}
                >
                    Skip
                </button>
            )}
        </div>
    );
};

export const TOUR_CLOSE = () => null;

export const TOUR_BADGE = () => null;
